import React, { useEffect, useState } from "react";
import {
	Grid,
	Typography,
	Button,
	TextField,
	MenuItem,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Paper,
	TablePagination,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import CustomButton from "../../../src/components/CustomButton/CustomButton";
import LoaderButton from "../../components/CustomButton/LoaderButton";
import ThumbUpAltRoundedIcon from "@mui/icons-material/ThumbDownAltRounded"
import ClearRoundedIcon from "@mui/icons-material/ClearRounded";
import Layout from "../../components/Wrappers/Layout";
import { Card, Alert } from "reactstrap";
import { AiOutlineSearch } from "react-icons/ai";
import { AiOutlineUserAdd } from "react-icons/ai";
import { useSelector, useDispatch } from "react-redux";
import moment from "moment";
import FormControl from "@mui/material/FormControl";
// import { FormControl } from "@mui/material";
import { getRoleList } from "../../redux/actions/getRoleListAction";
// import {
// 	MuiPickersUtilsProvider,
// 	DatePicker
// } from "@mui/material/pickers";
// import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns"

import {
	resetgetKybReportList,
	getKybReportListReq
} from "../../redux/actions/getKybReportListAction";

import {
	resetgetKybApproveReject,
	getKybApproveRejectReq
} from "../../redux/actions/getKybApproveRejectAction";

import success from "../../assets/img/success.png";
import failed from "../../assets/img/failed.png";

import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import "../../components/LoadingSpinner/spinner.css";

import { useHistory } from "react-router-dom";
// import getKybDetails from "./getKybDetails";
import Skeleton from "../../components/Skeleton/Skeleton";
import { Popconfirm, Tooltip, Spin } from "antd";
import Util from "../../validation/index";
import NotificationPopups from "../../NotificationPopup/NotificationPopups";
import SOLogout from "../../components/Logout/SOLogout";
import regenerateToken from "../../components/RegenerateToken/regenerateToken";
import { getWalletOwnerIdAndNameList } from "../../redux/actions/getWalletOwnerIdAndNameListAction";
import SearchIcon from "@mui/icons-material/Search";
import val from "../../getThemeDetails"
const useStyles = makeStyles({
	table: {
		minWidth: 650
	}
});

const AdminKybReport = () => {
	var date = new Date();
	const [selectedDate, setSelectedDate] = useState(
		new Date(date.getFullYear(), date.getMonth(), 1)
	);
	const [selectedToDate, setSelectedToDate] = useState(new Date());
	const [verificationId, setVerificationId] = useState("");
	const [walletOwnerId, setWalletOwnerId] = useState("");
	// const [partnerID, setpartnerID] = useState('');
	const [partnerId, setpartnerId] = useState('');


	const [parentId, setParentId] = useState("");
	const [verificationStatus, setVerificationStatus] = useState("All");
	const [role, setRole] = useState("");
	const navigate = useHistory();
	const [pageToggle, setPageToggle] = useState(false);
	const [getRoleStatus, setGetRoleStatus] = useState(false);
	const [getRoleResArray, setGetRoleResArray] = useState([]);
	const [getKybReportListArray, setGetKybReportListArray] = useState("");
	const [rowsPerPage, setRowsPerPage] = useState(5);
	const [getKybReportListStatus, setgetKybReportListStatus] = useState(false);
	const [getKybApprovedorRejectStatus, setgetKybApprovedorRejectStatus] =
		useState(false);
	const [getKybApprovedorRejectArray, setgetKybApprovedorRejectArray] =
		useState("");
	const [getWalletOwnerIdStatus, setGetWalletOwnerIdStatus] = useState(false);

	const [getWalletOwnerIdResArray, setGetWalletOwnerIdResArray] = useState([]);

	const [notificationOpen, setNotificationOpen] = React.useState(false);

	const [isLoading, setIsLoading] = useState(false);

	const [page, setPage] = useState(0);
	const classes = useStyles();

	const dispatch = useDispatch();
	// const partnerloginUser = useSelector(({ login }) => login);
	// var authToken = partnerloginUser.data.AuthToken;
	const regenerateTokenRes = useSelector(
		({ regenerateToken }) => regenerateToken
	);
	var authToken = regenerateTokenRes.data.AuthToken;

	const getRoleListRes = useSelector(({ getRoleList }) => getRoleList);

	const getKybReportListRes = useSelector(
		({ getKybReportList }) => getKybReportList
	);

	const getKybApproveRejectRes = useSelector(
		({ getKybApproveReject }) => getKybApproveReject
	);

	const getWalletOwnerIdRes = useSelector(
		({ getWalletOwnerIdAndNameList }) => getWalletOwnerIdAndNameList
	);

	const getRoleListStatusFunc = () => {
		if (getRoleStatus) {
			if (getRoleListRes.data.status == "success") {
				setGetRoleResArray([].concat(getRoleListRes.data.roleList));
			}
			if (getRoleListRes.data.status == "failed") {
				setGetRoleResArray(getRoleListRes.data);
				if (
					getRoleListRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					getRoleListRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
		}
	};

	useEffect(() => {
		getRoleListStatusFunc();
	}, [getRoleListRes.data.status]);

	const getRoleListReq = () => {
		setGetRoleStatus(true);
		dispatch(
			getRoleList(
				{
					ownerMasterRequestVO: {
						adminId: val.adminIDS,

						// adminId: 2,
						roleName: ""
					}
				},
				authToken
			)
		);
	};

	useEffect(() => {
		getRoleListReq();
	}, []);

	useEffect(() => {
		getKybApproveRejectResFunc();
	}, [getKybApproveRejectRes.data.status]);

	const getKybApproveRejectResFunc = () => {
		if (getKybApprovedorRejectStatus) {
			if (getKybApproveRejectRes.data.status == "Approved") {
				setNotificationOpen(true);
				setgetKybApprovedorRejectArray(getKybApproveRejectRes.data);
				gekybReportReq();
			}

			if (getKybApproveRejectRes.data.status == "Reject") {
				setNotificationOpen(true);
				setgetKybApprovedorRejectArray(getKybApproveRejectRes.data);
				gekybReportReq();
			}
		}
	};

	const handleAcceptOrRejectReq = (
		customerId,
		role,
		companyId,
		recommendation
	) => {
		console.log(customerId, role, companyId, recommendation);

		setgetKybApprovedorRejectStatus(true);
		const acceptOrRejectReq = {
			actionCustomerMasterRequestVO: {
				walletOwnerId: "1",
				customerId: customerId,
				role: role,
				userName: "mtransact",
				companyId: companyId,
				recommendation: recommendation
			}
		};
		return dispatch(getKybApproveRejectReq(acceptOrRejectReq, authToken));
	};
	// const handleChangeWallet = ({ target: { name, value } }) => {
	// 	if (name === "partnerID") {
	// 		setpartnerID(value == "Select Owner ID" ? "" : value);


	// 	}
	// };
	const handleChange = ({ target: { name, value } }) => {
		if (name === "verificationId") {
			// setVerificationId(value);
			Util.verifyNumber(value)
				? setVerificationId(value)
				: setVerificationId(verificationId);
		}

		if (name === "parentId") {
			// setParentId(value);
			Util.verifyNumber(value) ? setParentId(value) : setParentId(parentId);
		}

		if (name === "verificationStatus") {
			setVerificationStatus(value);
		}

		if (name === "role") {
			setRole(value == "Select Role" ? "" : value);
		}
		// if (name === 'partnerID') {
		// 	setpartnerID(value);
		// }
		if (name === 'partnerId') {
			setpartnerId(value);

			// setautocompleteDataName("");



		}
		// if (name === "walletOwnerId") {
		// 	// setWalletOwnerId(value);
		// 	Util.verifyNumber(value)
		// 		? setWalletOwnerId(value)
		// 		: setWalletOwnerId(walletOwnerId);
		// }
	};

	const gekybReportReq = () => {
		setgetKybReportListStatus(true);
		setIsLoading(true);
		const gekybReportReq = {
			loginDetails: {
				walletOwnerId: partnerId == "Select Owner Id" ? "" : partnerId.split("-")[0],
			},
			actionCustomerMasterRequestVO: {
				customerId: parentId,
				verificationId: verificationId,
				fdtStamp: moment(selectedDate).format("DD/MM/YYYY"),
				tdtStamp: moment(selectedToDate).format("DD/MM/YYYY"),
				verificationStatus:
					verificationStatus == "All" ? "" : verificationStatus,
				role: role
			}
		};
		return dispatch(getKybReportListReq(gekybReportReq, authToken));
	};

	// {
	// 	loginDetails: {
	// 		walletOwnerId: walletOwnerId
	// 	},

	// 	actionCustomerMasterRequestVO: {
	// 		customerId: parentId,
	// 		verificationId: verificationId,
	// 		fdtStamp: moment(selectedDate).format("DD/MM/YYYY"),
	// 		tdtStamp: moment(selectedToDate).format("DD/MM/YYYY"),
	// 		verificationStatus:
	// 			verificationStatus == "All" ? "" : verificationStatus,
	// 		role: role
	// 		// custRegId: "","All" ? "" : value
	// 		// customerId: "",
	// 		// verificationStatus: "",
	// 		// fdtStamp: "",
	// 		// tdtStamp: "",
	// 		// role: "",
	// 	}
	// };

	const handleDateChange = (date) => {
		setSelectedDate(date);
	};

	const handleToDateChange = (date) => {
		setSelectedToDate(date);
	};

	const handleChangePage = (event, newPage) => {
		setPage(newPage);
	};

	const handleChangeRowsPerPage = (event) => {
		setRowsPerPage(parseInt(event.target.value, 10));
		setPage(0);
	};

	const handleNoticationClose = () => {
		setNotificationOpen(false);
	};

	const getKybReportListResFunc = () => {
		if (getKybReportListStatus) {
			if (getKybReportListRes.data.status == "success") {
				setGetKybReportListArray(
					[].concat(getKybReportListRes.data.customerMasterDetailsRequestVOList)
				);
				setIsLoading(false);
			}
			if (getKybReportListRes.data.status == "failed") {
				setGetKybReportListArray(getKybReportListRes.data);
				setIsLoading(false);
				NotificationPopups(
					"error",
					"Failed",
					getKybReportListRes.data.description
				);
				if (
					getKybReportListRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					getKybReportListRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
			if (getKybReportListRes.data.status == "Failed") {
				setGetKybReportListArray(getKybReportListRes.data);
				setIsLoading(false);
				NotificationPopups(
					"error",
					"Failed",
					getKybReportListRes.data.description
				);
				if (
					getKybReportListRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					getKybReportListRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}

			if (getKybReportListRes.data.status == "Not Found") {
				setGetKybReportListArray(getKybReportListRes.data);
				setIsLoading(false);
				NotificationPopups(
					"error",
					"Failed",
					getKybReportListRes.data.description
				);
			}
			if (getKybReportListRes.data.status == "INVALID REQUEST") {
				setGetKybReportListArray(getKybReportListRes.data);
				setIsLoading(false);
			}
		}
	};

	useEffect(() => {
		getKybReportListResFunc();
	}, [getKybReportListRes.data.status]);

	const sendVerificationId = (id, customerId, userRole) => {
		setPageToggle(true);
		navigate.push({
			pathname: `/index/KybDetails`,
			state: { param1: `${id}`, param2: `${customerId}`, param3: `${userRole}` }
		});
	};

	const getWalletOwnerIdStatusFunc = () => {
		if (getWalletOwnerIdStatus) {
			console.log("Lcs", getWalletOwnerIdRes)
			if (getWalletOwnerIdRes.data.status == "success") {
				console.log("Lcssss", getWalletOwnerIdRes)

				setGetWalletOwnerIdResArray(
					[].concat(getWalletOwnerIdRes.data.ownerList)
				);
			}
			if (getWalletOwnerIdRes.data.status == "failed") {
				setGetWalletOwnerIdResArray(getWalletOwnerIdRes.data);
				if (
					getWalletOwnerIdRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					getWalletOwnerIdRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId || localStorage.getItem("walletOwnerId"));
				}
			}
			if (getWalletOwnerIdRes.data.status == "NOT FOUND") {
				setGetWalletOwnerIdResArray(getWalletOwnerIdRes.data);
				if (
					getWalletOwnerIdRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					getWalletOwnerIdRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
		}
	};

	const getWalletOwnerIdAndNameListReq = () => {
		setGetWalletOwnerIdStatus(true);
		dispatch(
			getWalletOwnerIdAndNameList(
				{
					loginDetails: {
						adminId: val.adminIDS

						// adminId: "2"
					}
				},
				authToken
			)
		);
	};
	useEffect(() => {
		// if (regenerateTokenRes.data.status == "success") {

		getWalletOwnerIdAndNameListReq();
		// }
	}, []);
	useEffect(() => {
		console.log("made get req");
		getWalletOwnerIdStatusFunc();
	}, [getWalletOwnerIdRes]);

	// useEffect(() => {
	// 	getWalletOwnerIdStatusFunc();
	// }, [getWalletOwnerIdRes.data.status]);
	return (
		<>
			<>
				<Layout>
					<Card>
						<Grid
							container
							spacing={2}
							style={{ padding: "25px", marginTop: "2rem" }}
						>
							<Grid item xs={12} sm={6} md={4} lg={3}>
								<FormControl fullWidth>
									<LocalizationProvider dateAdapter={AdapterDateFns}>
										<DatePicker
											label="From Date"
											format="MM/dd/yyyy"
											value={selectedDate}
											onChange={handleDateChange}
											disableFuture={true}
										/>
									</LocalizationProvider>
								</FormControl>
							</Grid>

							<Grid item xs={12} sm={6} md={4} lg={3}>
								<FormControl fullWidth>
									<LocalizationProvider dateAdapter={AdapterDateFns}>
										<DatePicker
											label="To Date"
											format="MM/dd/yyyy"
											value={selectedToDate}
											onChange={handleToDateChange}
											disableFuture={true}
										/>
									</LocalizationProvider>
								</FormControl>
							</Grid>

							<Grid item xs={12} sm={6} md={4} lg={3}>
								<TextField
									autoFocus
									margin="dense"
									variant="standard"
									id="name"
									label="Verification Id"
									type="text"
									fullWidth
									value={verificationId || ""}
									name="verificationId"
									onChange={handleChange}
								/>
							</Grid>
							{/* <Grid item xs={12} sm={6} md={4} lg={3}>
								<TextField
									required
									autoFocus
									margin="dense"
									variant="standard"

									id="name"
									label="Owner Id"
									type="name"
									fullWidth
									defaultValue={"Select Owner Id" || partnerID }
									name="partnerID"
									onChange={handleChangeWallet}
								>
									<MenuItem value="Select Owner Id">
										Select Owner Id
									</MenuItem>
						
									{getWalletOwnerIdRes.data.ownerList &&
										getWalletOwnerIdRes.data.ownerList &&
										[]
											.concat(getWalletOwnerIdResArray)
											.map((dropdown) => (
												<MenuItem value={dropdown}>{dropdown}</MenuItem>
											))}
								</TextField>
							</Grid> */}

							<Grid item xs={12} sm={6} md={4} lg={3}>
								<TextField
									required
									margin="dense"
									variant="standard"

									select
									style={{ marginTop: "3px" }}

									color="primary"
									type="text"
									label="Owner ID"
									fullWidth
									name="partnerId"
									// value={walletOwnerId}
									defaultValue={"Select Owner Id" || partnerId}
									onChange={handleChange}

								>
									<MenuItem value="Select Owner Id" selected="Select Owner Id">
										Select Owner Id
									</MenuItem>
									{console.log("GETARRAYowner", getWalletOwnerIdResArray)}
									{getWalletOwnerIdResArray.status !== "failed" && getWalletOwnerIdRes.data.ownerList &&
										getWalletOwnerIdResArray.map((x) => (
											<MenuItem value={x.split("-")[0]}>{x}</MenuItem>
										))}
								</TextField>
							</Grid>
							<Grid item xs={12} sm={6} md={4} lg={3}>
								<TextField
									autoFocus
									margin="dense"
									id="name"
									variant="standard"

									label="Parent Id"
									type="text"
									fullWidth
									value={parentId}
									name="parentId"
									onChange={handleChange}
								/>
							</Grid>

							<Grid item xs={12} sm={6} md={4} lg={3}>
								<TextField
									select
									autoFocus
									margin="dense"
									id="name"


									label="Verification Status"
									type="name"
									fullWidth
									variant="standard"
									name="verificationStatus"
									// value={verificationStatus || ""}
									defaultValue={"All" || verificationStatus}
									onChange={handleChange}
								>
									<MenuItem value="All" selected="All">
										All
									</MenuItem>
									<MenuItem value="Approve">Approve</MenuItem>
									<MenuItem value="Error">Error</MenuItem>

									<MenuItem value="Failed">Failed</MenuItem>
									<MenuItem value="Pending">Pending</MenuItem>

									<MenuItem value="Reject">Reject</MenuItem>
									<MenuItem value="Review">Review</MenuItem>
								</TextField>
							</Grid>

							<Grid item xs={12} sm={6} md={4} lg={3}>
								<TextField
									select
									autoFocus
									margin="dense"
									id="name"
									label="Role"
									type="name"
									fullWidth
									variant="standard"
									name="role"
									// value={role || ""}
									defaultValue={"Select Role" || role}
									onChange={handleChange}
								>
									<MenuItem value="Select Role" selected="Select Role">
										Select Role
									</MenuItem>
									{getRoleListRes.data.roleList &&
										getRoleResArray.map((x) => (
											<MenuItem value={x.role}>{x.role}</MenuItem>
										))}
								</TextField>
							</Grid>
						</Grid>

						<Grid
							container
							style={{
								padding: "10px",
								marginTop: "1.5rem",
								marginBottom: "15px"
							}}
						>
							<Grid item xs={12} sm={6} md={4} lg={3}>
								{/* <Button
									style={{
										marginLeft: "0.7rem",
										backgroundColor: "#00b9f5",
										color: "white"
									}}
									endIcon={<AiOutlineSearch />}
									variant="contained"
									onClick={gekybReportReq}
								>
									Search
								</Button> */}
								<CustomButton
									style={{
										padding: "8px",
										marginLeft: "15px"
									}}
									onClick={gekybReportReq}
								>
									Search <SearchIcon />
								</CustomButton>
							</Grid>
							<Grid item md={7}></Grid>
						</Grid>
					</Card>

					{/* {getKybReportListStatus && getKybReportListArray.isLoading && (
						<div>... Loading </div>
					)} */}

					{isLoading ? (
						<LoadingSpinner />
					) : getKybReportListArray.length == undefined ||
						getKybReportListArray.status == "NOT FOUND" ||
						getKybReportListArray.status == "INVALID REQUEST" ||
						getKybReportListArray.status == "failed" ||
						!getKybReportListStatus ? (
						<Card>
							<Grid
								container
								style={{
									padding: "10px"
								}}
							>
								<Grid xs={12} sm={12} md={12} lg={12}>
									<Typography variant="body1" style={{ fontWeight: "700" }}
										className="themeText"

									>
										Report Table
									</Typography>
								</Grid>
								<Grid xs={12} sm={12} md={12} lg={12}>
									<Alert
										className="my-3 tableHeaderColor"
										variant="secondary"
									// style={{ backgroundColor: "#00b9f5", color: "white" }}
									>
										No Records Found!
									</Alert>
								</Grid>
							</Grid>
						</Card>
					) : (
						<Card>
							<Grid
								container
								style={{
									padding: "10px"
								}}
							>
								<Grid xs={12} sm={12} md={12} lg={12}>
									<Typography variant="body1" style={{ fontWeight: "700" }}
										className="themeText"

									>
										Report Table
									</Typography>
								</Grid>
								<TableContainer component={Paper} className="text-nowrap my-3">
									<Table
										className={classes.table}
										size="small"
										aria-label="a dense table"
									>
										<TableHead>
											<TableRow className="tableHeaderColor">
												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													Verification ID
												</TableCell>
												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													Owner ID
												</TableCell>
												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													Parent ID
												</TableCell>
												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													Role
												</TableCell>
												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													Company ID
												</TableCell>
												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													Company Name
												</TableCell>
												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													Timestamp
												</TableCell>
												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													Verification Status
												</TableCell>
												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													Action
												</TableCell>
											</TableRow>
										</TableHead>
										<TableBody>
											{getKybReportListArray &&
												[]
													.concat(getKybReportListArray)
													.slice(
														page * rowsPerPage,
														page * rowsPerPage + rowsPerPage
													)
													.map((row) => (
														<TableRow key={row.customerId}>
															<TableCell align="center">
																<span
																	style={{
																		color: "#00b9f5",
																		fontWeight: "bold",
																		textDecoration: "underline",
																		cursor: "pointer"
																	}}
																	onClick={() =>
																		sendVerificationId(
																			row.verificationId,
																			row.customerId,
																			row.userRole
																		)
																	}
																>
																	{row.verificationId}
																</span>
															</TableCell>
															<TableCell align="center">-</TableCell>
															<TableCell align="center">
																{row.companyId}
															</TableCell>
															<TableCell align="center">
																{row.userRole}
															</TableCell>
															<TableCell align="center">
																{row.companyId}
															</TableCell>

															<TableCell align="center">
																{row.companyName}
															</TableCell>
															<TableCell align="center">
																{row.requestTime}
															</TableCell>
															<TableCell align="center">
																{row.verificationStatus}
															</TableCell>

															<TableCell align="center">
																{row.verificationStatus == "Pending" && (
																	<>
																		<Tooltip title="Approve">
																			<CustomButton
																				style={{
																					padding: "8px",
																					width: "50px"
																				}}
																				onClick={() =>
																					handleAcceptOrRejectReq(
																						row.customerId,
																						row.userRole,
																						row.companyId,
																						"Approve"
																					)
																				}
																			>
																				{
																					<ThumbUpAltRoundedIcon
																						style={{
																							color: "#fff",
																							fontSize: "20px"
																						}}
																					/>
																				}
																			</CustomButton>
																		</Tooltip>

																		<Tooltip title="Reject">
																			<CustomButton
																				style={{
																					padding: "4px",
																					width: "48px",
																					marginLeft: "5px"
																				}}
																				onClick={() =>
																					handleAcceptOrRejectReq(
																						row.customerId,
																						row.userRole,
																						row.companyId,
																						"Reject"
																					)
																				}
																			>
																				{
																					<ClearRoundedIcon
																						style={{
																							color: "#fff",
																							fontSize: "28px"
																						}}
																					/>
																				}
																			</CustomButton>
																		</Tooltip>
																	</>
																)}

																{row.verificationStatus == "Approve" && (
																	<>
																		<Tooltip title="Approve">
																			<CustomButton
																				style={{
																					padding: "8px",
																					width: "50px"
																				}}
																				disabled={true}
																			>
																				{
																					<ThumbUpAltRoundedIcon
																						style={{
																							color: "#fff",
																							fontSize: "20px"
																						}}
																					/>
																				}
																			</CustomButton>
																		</Tooltip>

																		<Tooltip title="Reject">
																			<CustomButton
																				style={{
																					padding: "4px",
																					width: "48px",
																					marginLeft: "5px"
																				}}
																				disabled={true}
																			// onClick={() =>
																			//   handleAcceptOrRejectReq(
																			//     row.customerId,
																			//     row.userRole,
																			//     row.companyId,
																			//     "Reject"
																			//   )
																			// }
																			>
																				{
																					<ClearRoundedIcon
																						style={{
																							color: "#fff",
																							fontSize: "28px"
																						}}
																					/>
																				}
																			</CustomButton>
																		</Tooltip>
																	</>
																)}

																{row.verificationStatus == "Reject" && (
																	<>
																		<Tooltip title="Approve">
																			<CustomButton
																				style={{
																					padding: "8px",
																					width: "50px"
																				}}
																				disabled={true}
																			>
																				{
																					<ThumbUpAltRoundedIcon
																						style={{
																							color: "#fff",
																							fontSize: "20px"
																						}}
																					/>
																				}
																			</CustomButton>
																		</Tooltip>

																		<Tooltip title="Reject">
																			<CustomButton
																				style={{
																					padding: "4px",
																					width: "48px",
																					marginLeft: "5px"
																				}}
																				disabled={true}
																			>
																				{
																					<ClearRoundedIcon
																						style={{
																							color: "#fff",
																							fontSize: "28px"
																						}}
																					/>
																				}
																			</CustomButton>
																		</Tooltip>
																	</>
																)}
															</TableCell>
														</TableRow>
													))}
										</TableBody>
									</Table>
									<TablePagination
										rowsPerPageOptions={[5, 10, 25]}
										component="div"
										count={getKybReportListArray.length}
										rowsPerPage={rowsPerPage}
										page={page}
										onPageChange={handleChangePage}
										onRowsPerPageChange={handleChangeRowsPerPage}
									/>
								</TableContainer>
							</Grid>
						</Card>
					)}
				</Layout>

				{getKybApprovedorRejectArray.status == "Approved" && (
					<div>
						<Dialog open={notificationOpen} onClose={handleNoticationClose}>
							<DialogContent
								className="text-center"
								style={{ backgroundColor: "#00b9f51c" }}
							>
								<img src={success} alt="" width="100px" className="my-2" />
							</DialogContent>
							<DialogContent>
								<h4
									style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
								>
									{getKybApprovedorRejectArray.description}
								</h4>
							</DialogContent>
							<DialogActions style={{ justifyContent: "center" }}>
								<Button
									style={{
										margin: "10px 0",
										backgroundColor: "#00b9f5",
										color: "white"
									}}
									variant="contained"
									onClick={handleNoticationClose}
								>
									Ok
								</Button>
							</DialogActions>
						</Dialog>
					</div>
				)}

				{getKybApprovedorRejectArray.status == "Reject" && (
					<div>
						<Dialog open={notificationOpen} onClose={handleNoticationClose}>
							<DialogContent
								className="text-center"
								style={{ backgroundColor: "#00b9f51c", width: "255px" }}
							>
								<img src={failed} alt="" width="100px" className="my-2" />
							</DialogContent>
							<DialogContent>
								<h4
									style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
								>
									{getKybApprovedorRejectArray.description
										.split("|")
										.map((x) => (
											<p style={{ margin: "3px" }}>{x}</p>
										))}
								</h4>
							</DialogContent>
							<DialogActions style={{ justifyContent: "center" }}>
								<Button
									style={{
										marginBottom: "10px",
										backgroundColor: "#00b9f5",
										color: "white"
									}}
									variant="contained"
									onClick={handleNoticationClose}
								>
									Ok
								</Button>
							</DialogActions>
						</Dialog>
					</div>
				)}
			</>
		</>
	);
};

export default AdminKybReport;
